import { useMemo } from "react";
import { GridDataTableColumn } from "../GridDataTable/GridDataTableColumn";
import { DateCell } from "../GridDateFormatter/useGridDateFormatter";
import { buildLinkCell } from "../GridLinkColumn/useDataTableLinkColumnMapper";
import { BooleanCell } from "../GridBooleanCell/useGridBooleanCell";
import { EllipsisCell } from "../GridTextEllipsisCell/useGridTextEllipsisCell";

//import { buildLinkCell } from '../GridLinkColumn/useDataTableLinkColumnMapper';

// const DateCell    = ({ value }: { value: string }) => DateService.ToDateTime(value);
// const BooleanCell = ({ value }: { value: unknown }) => { /* ... */ };
// const EllipsisCell = ({ value }: { value: string }) => ( /* ... */ );
export interface UseGridColumnOptions {
  /** The column definitions that may contain date-typed columns. */
  columns: GridDataTableColumn[];
}

export function useDataTableColumnMapper({
  columns,
}: UseGridColumnOptions): GridDataTableColumn[] {
  return useMemo(() => {
    return columns.map((col) => {
    // Respect user-defined Cell — never overwrite
    if (col.Cell) return col;
    // Link columns take priority
    if (col.linkColumn && col.linkUrl) {
      return {
        ...col,
        Cell: buildLinkCell(
          col.linkUrl, col.linkIcon, col.linkOpenWindow ?? false,
          col.linkShowValue ?? true, col.linkUrlHasPlaceHolder,
        ),
      };
    }
    if (col.type === 'date')    return { ...col, Cell: DateCell };
    if (col.type === 'boolean') return { ...col, Cell: BooleanCell };
    if (col.ellipsisCell)       return { ...col, Cell: EllipsisCell };
    return col;
  });
  }, [columns]);
}
